export const environment = {
  production: true,
  region: 'us-east-1',
  role: 'career',
  env: 'prod'
};
